<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title" style="width: 100%">
        <button onclick="javascript:location.href='../Fee/FeeDeposit'" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row" style="margin-top: 10px">
        <div class="col-md-12">
          <div class="table-responsive">
            <table id="feeDepositRecord" class="table table-bordered table-striped table-color table-sm">
              <thead class="bg-info">
                <tr>
                  <th>Challan No.</th>
                  <th>Form No.</th>
                  <th>Student Name</th>
                  <th>Father Name</th>
                  <th>CNIC</th>
                  <th>Program</th>
                  <th>Amount</th>
                  <th>Deposit Date</th>
                  <!--<th>Action</th>-->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in deposit">
                  <td>{{item.ChallanNo}}</td>
                  <td>{{item.FormNo}}</td>
                  <td>{{item.Name}}</td>
                  <td>{{item.FathersName}}</td>
                  <td>{{item.CNIC}}</td>
                  <td>{{item.ProgramName}}</td>
                  <td align="right">{{item.TotalAmount.toLocaleString()}}</td>
                  <td>{{item.DepositDate}}</td>
                  <!--<td>
                    <button class="btn btn-info" v-on:click="printDepositSlip(item.FeeDepositID)">Print</button>
                  </td>-->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        deposit: [],
      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },

    updated: function () {
      if (this.deposit.length != 0) {
        $('#feeDepositRecord').DataTable();
      }
    },

    methods: {
      pageLoad: function () {
        var vm = this;
        startReq();
        axios.post('/api/FeeApi/loadFeeDeposits')
          .then(function (pl) {
            endReq();
            vm.deposit = pl.data["lst"];
          })
      },

      printDepositSlip(id) {
        var vm = this;
        startReq();
        axios.post('/api/FeeApi/printSlip?ID=' + id)
          .then(function (pl) {
            endReq();
            window.open("../Fee/FeeDepositPrint", "_blank");
          })
      }
    }
  })

</script>

<style>
  table thead tr th {
    background-color: #17a2b8;
    color: white;
  }

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fee/FeeDepositRecord.vue